import { createSelector } from '@reduxjs/toolkit';

const getInfiniteDataState = (state) => state.infiniteData;

export const getInfiniteData = (entityKey) =>
  createSelector(getInfiniteDataState, (state) => state?.[entityKey]);
